import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { getListItems } from '../../public/utility'
class MethodDeviceDetailDiv extends React.Component {
    state = {
        id: this.props.id,
        methodID: this.props.methodID,
        bReadOnly: this.props.bReadOnly,
        processing: 0,//限制并发操作
    }

    componentDidMount = () => {
        const { id, methodID } = this.props
        this.GetMethodDevice(id, methodID)
    }

    GetMethodDevice = (id, methodID) => {
        Tyan.doPostEvent({
            event: 'GetMethodDevice',
            data: { id, methodID },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
                setTimeout(this.handelFinish, 100)
            }
        })
    }
    handelBegin = () => this.setState((state) => ({ processing: state.processing + 1 }))
    handelFinish = () => this.setState((state) => ({ processing: state.processing - 1 }))

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    handlerSave = () => {
        const { id, methodID, changedValues基本信息 } = this.state
        const { onSave, onClose } = this.props
        
        Tyan.doPostEvent({
            event: 'SaveMethodDevice',
            data: { id, methodID, changedValues基本信息, },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, id }) => {
                setTimeout(this.handelFinish, 100)
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteMethodDevice',
                data: { id },
                onRequest: this.handelBegin,
                onEnd: ({ errorMessage }) => {
                    setTimeout(this.handelFinish, 100)
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handleNumberChange = (v) => {
        Tyan.doPostEvent('GetInstrumentInfo', {
            data: { 设备: v },
            onEnd: ({ errorMessage, options, objInstrument }) => {
                if (options) {
                    this.setState({ optionsParas: { ...this.state.optionsParas, 设备: options['设备'] } })
                }
                if (objInstrument) {
                    Tyan.utility.changeItemsValue(this, '基本信息',
                        [
                            '设备编号', '设备名称',
                        ],
                        [
                            objInstrument['InstrumentNumber'], objInstrument['InstrumentName'],
                        ]
                    )
                }
            }
        })
    }

    bChanged = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return hasChangedValues(this) && values.设备编号 !== '' && values.设备名称 !== ''
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return [
            { _select: '设备编号', name: '设备编号', optionName: '设备', minWidth: '90%', required: true, onChange: (v) => this.handleNumberChange(v), forceSelection: false, editable: true, },
            { _text: '设备名称', name: '设备名称', minWidth: '90%', required: true },
            { _int: '排序', name: '排序', minWidth: '90%', textAlign: 'left' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id, bReadOnly } = this.props
        const { initValues基本信息, processing } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="600"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged(), cdt: () => !bReadOnly },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && !bReadOnly, handler: this.handlerDelete, disabled: this.bChanged() },
                    { _button: this.bChanged() ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly,/*   fullblock: true  */ },
                ]}
        />
    }
}

export default connect()(MethodDeviceDetailDiv)